export function playPuck() {
  const audio = new Audio('/sound/puck.mp3');
  audio.volume = 0.03;
  audio.play();
}
